import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { options } from "../../../../components/contractListItem";
import { LOCALIZE_DATE } from "../../../../setup/constants";
import { IContractProps } from "../../models";
import styles from "./styles.module.scss";

export const MainDetailsHeading = ({
  contract,
  unAuthenticated = false,
}: IContractProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.text_wrapper}>
      <h1>{contract?.itemDetail?.title}</h1>
      <p
        className={classNames(
          "subtitle2",
          unAuthenticated && styles.limitDescription
        )}>
        <span className={"subtitle2"}>
          {`${t("lbl_contract_details_contract_id_web")} ${
            contract?.shortId
          }# . `}
        </span>

        <span className={classNames("p2", "g600")}>
          {new Date(contract.createdAt).toLocaleDateString(
            LOCALIZE_DATE,
            options
          )}
        </span>
      </p>
      {unAuthenticated && contract?.itemDetail?.description && (
        <p
          className={classNames(
            unAuthenticated ? styles.limitDescription : styles.description
          )}>
          {contract?.itemDetail?.description}
        </p>
      )}
    </div>
  );
};
